import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-weight-rule-breach',
  templateUrl: './jockey-weight-rule-breach.component.html',
  styleUrls: ['./jockey-weight-rule-breach.component.scss']
})
export class JockeyWeightRuleBreachComponent implements OnInit {
  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: number|boolean
  };
  userId: number;
  jockeyWeights: {
    ruleBreach: boolean
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: this.detectRuleBreach()
    };

    this.detectRuleBreach();

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });
  }

  detectRuleBreach(asBoolean = true): boolean|number {
    const weightIn = Number(this.jockey.weights['I'].weightRecorded);
    const weightOut = Number(this.jockey.weights['O'].weightRecorded);
    if (weightIn - weightOut >= 2 || weightIn - weightOut < -1) {
      return asBoolean ? Boolean(weightIn - weightOut) : weightIn - weightOut;
    } else {
      return asBoolean ? false : 0;
    }
  }

  updateRuleBreach(ruleBreach) {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      weightRecorded: this.jockey.weights['I'].weightRecorded,
      weightDisplayed: this.jockey.weights['I'].weightDisplayed,
      ruleBreach: ruleBreach,
      raw: 'rule-breach',
      weighed: 'I',
      type: this.jockey.weights['I'].type,
      updatedBy: this.userId
    };

    console.log(`[ DEBUG ] Sending payload`, payload);
    this.apiService.updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.jockey.jockeyName} rule breach status has been saved.`, 'Rule Breach');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the rule breach status. Check your connection and Try again.`, 'Rule Breach');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
